<template>
  <div>
    <b-alert variant="secondary" show>
      <div
        style="display: flex; align-items: end; justify-content: end"
        class="mb-1 alert-heading"
      >
        <p class="mr-1"><b> Invoice Date Range (current month):</b></p>
        <flat-pickr
          @input="onReportDate"
          v-model="reportDateRange"
          style="width: 400px"
          :config="{ mode: 'range', ...$flatPickrConfig, maxDate: new Date() }"
          placeholder="Select Month Range"
          class="form-control mr-1"
        />
        <b-button
          @click="showModal"
          class="mr-1"
          v-b-tooltip.hover
          title="apply filters"
          variant="secondary"
          size="sm"
          ><feather-icon style="cursor: pointer" icon="FilterIcon" size="23"
        /></b-button>
        <b-button
          v-b-tooltip.hover
          title="export as excel"
          variant="secondary"
          size="sm"
          @click="onExportExcel"
          ><feather-icon style="cursor: pointer" icon="DownloadIcon" size="23"
        /></b-button>
        <b-button
          style="margin-left: 1%"
          variant="secondary"
          @click="handleResetButtonClicked"
          >Reset</b-button
        >
      </div>
    </b-alert>
    <div v-if="filterApplied == true" style="margin-top: 2%; margin-bottom: 2%">
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvoiceArray.length > 0"
      >
        Invoice Number : {{ appliedFilters.selectedInvoiceArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedaccArray.length > 0"
      >
        Account : {{ appliedFilters.selectedaccArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedCurrencyArray.length > 0"
      >
        Currency : {{ appliedFilters.selectedCurrencyArray.toString() }}
      </b-badge>
    </div>
    <div style="overflow-x: auto">
      <table ref="exportable_table">
        <tr style="background: lightgrey">
          <th>
            Invoice Number
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>

          <th>
            Account
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>Licensee</th>
          <th>Revenue Name</th>
          <th>Invoice Date</th>
          <th>Payment Date</th>
          <th>
            Currency
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>Invoice Net Amount (excl. VAT)</th>
          <th>VAT (Accounting Code)</th>
          <th>VAT Percent</th>
          <th>VAT Amount</th>
          <th>Invoice Amount (incl. VAT)</th>
          <th>Exchange Rate</th>
          <th>Total CHF</th>
        </tr>
        <tr
          v-for="(item, index) in bookKeepingReportData"
          :key="index"
          :style="
            item.invoice_unique_id &&
            item.invoice_unique_id.toString().includes('Total')
              ? 'background:lightGrey;border-bottom:3px solid grey '
              : ''
          "
        >
          <td>
            <a
              @click="
                () =>
                  (invId = item.revenue_invoice_id
                    ? item.revenue_invoice_id
                    : null)
              "
              v-b-modal.invModal
              ><u>{{ item.invoice_unique_id }}</u></a
            >
          </td>

          <td>{{ item.iban }}</td>
          <td>{{ item.company }}</td>
          <td>{{ item.additional_cost_name }}</td>
          <td>{{ item.invDate ? item.invDate : "" }}</td>
          <td>{{ item.payDate ? item.payDate : "" }}</td>
          <td>{{ item.selectedCurrency }}</td>
          <td style="text-align: right">
            {{ formatCurrency(item.amount) }}
          </td>
          <td>{{ item.vatCode }}</td>
          <td>{{ item.vatPercent }}</td>
          <td style="text-align: right">{{ formatCurrency(item.vatAmt) }}</td>
          <td style="text-align: right">{{ formatCurrency(item.totalAmt) }}</td>
          <td style="text-align: right">
            {{ item.exchange_rate ? formatExchangeRate(item.exchange_rate) : 1 }}
          </td>
          <td style="text-align: right">
            {{ item.base_chf_total ? formatCurrency(item.base_chf_total) : "" }}
          </td>
        </tr>
      </table>
    </div>
    <div>
      <b-modal
        no-close-on-backdrop
        ref="my-modal"
        hide-footer
        title="Report Filters"
      >
        <div class="d-block text-left">
          <b-form-group id="Invoice" label="Invoice Numbers">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedInvoiceArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="invoiceNumbersArray"
            />
          </b-form-group>
          <b-form-group id="Account" label="Account">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedaccArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="accNumbersArray"
            />
          </b-form-group>
          <b-form-group id="Currency" label="Currency">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedCurrencyArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="currencyArray"
            />
          </b-form-group>
          <!-- <b-form-group label="Invoice Date Range">
            <flat-pickr
              :config="{ mode: 'range', ...$flatPickrConfig }"
              placeholder="Select"
              class="form-control"
              v-model="filters.selectedInvDateRange"
            />
          </b-form-group> -->
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="onApplyFilters"
          >Apply Filters</b-button
        >
        <b-button variant="outline-info" block @click="handleResetButtonClicked"
          >Reset Filters</b-button
        >
      </b-modal>
    </div>
    <b-modal v-if="invId" size="xl" id="invModal" title="Invoice"
      ><preview-invoice :invId="invId" />
    </b-modal>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  VBTooltip,
  BModal,
  BFormGroup,
  BBadge,
  BAlert,
} from "bootstrap-vue";
import { GetAdditionalRevBookKeepingRevenueReport } from "@/apiServices/BookkeepingServices";
import moment from "moment";
import { formatCurrency, formatExchangeRate } from "@/utils/helpers";
import qs from "qs";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import PreviewInvoice from "@/views/pages/Revenue/PreviewInvoice.vue";
export default {
  data() {
    return {
      filterApplied: false,
      reportDateRange: null,
      reportFromDate: null,
      reportToDate: null,
      invoiceNumbersArray: [],
      movieArray: [],
      territoryArray: [],
      rightArray: [],
      uniqueIdArray: [],
      accNumbersArray: [],
      currencyArray: [],
      filters: {
        selectedInvoiceArray: [],
        selectedMovieArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedTerArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
        selectedInvDateRange: null,
      },
      appliedFilters: {
        selectedInvoiceArray: [],
        selectedMovieArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedTerArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
        selectedInvDateRange: null,
      },
      BASE_URL: process.env.VUE_APP_BASEURL,
      moment: moment,
      tabIndex: 0,
      bookKeepingReportData: [],
      actualBookKeepingReportData: [],
      invId: null,
      applyFilterClicked: false,
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BTabs,
    BTab,
    BCard,
    FeatherIcon,
    BButton,
    VBTooltip,
    BModal,
    BFormGroup,
    vSelect,
    flatPickr,
    BBadge,
    PreviewInvoice,
    BAlert,
  },
  // beforeMount() {
  //   this.filterApplied = false;
  //   let today = moment().format("YYYY-MM-DD");
  //   let previous = moment().startOf("month").format("YYYY-MM-DD");
  //   this.reportDateRange = previous + " to " + today;

  //   this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
  //   this.reportToDate = moment().endOf("month").format("YYYY-MM-DD");
  //   this.getBookkeepingReport();
  // },
  beforeMount() {
  this.filterApplied = false;

  // Get today's date
  const today = moment().format("YYYY-MM-DD");

  // Check if today is the 1st day of the month
  const isFirstDayOfMonth = moment().date() === 1;

  let previous;

  if (isFirstDayOfMonth) {
    previous = moment().startOf("month").subtract(15, "days").format("YYYY-MM-DD");
  } else {
    previous = moment().startOf("month").format("YYYY-MM-DD");
  }
  this.reportDateRange = previous + " to " + today;
  this.reportFromDate = previous;
  this.reportToDate = today; 
  this.getBookkeepingReport();
},
  methods: {
    formatCurrency,
    formatExchangeRate,
    onReportDate() {
      if (this.reportDateRange) {
        let from = null;
        let to = null;
        const today = new Date();
        const isFirstDayOfMonth = today.getDate() === 1;

        // if (isFirstDayOfMonth) {
        //   from = new Date(today);
        //   from.setDate(today.getDate() - 15);

        //   // Set `to` to today
        //   to = new Date(today);
        //   this.reportDateRange = `${from.toISOString().split("T")[0]} to ${
        //     to.toISOString().split("T")[0]
        //   }`;
        // } else {
        //   if (this.reportDateRange.split("to").length > 1) {
        //     from = new Date(this.reportDateRange.split("to")[0]);
        //     to = new Date(this.reportDateRange.split("to")[1]);
        //   } else {
        //     from = new Date(this.reportDateRange.split("to")[0]);
        //     to = new Date(this.reportDateRange.split("to")[0]);
        //   }
        // }
        from = this.reportDateRange.split("to")[0];
        to = this.reportDateRange.split("to")[1];
        // this.reportFromDate = `${from.getFullYear()}-${(
        //   "0" +
        //   (from.getMonth() + 1)
        // ).slice(-2)}-${("0" + from.getDate()).slice(-2)}`;
        this.reportFromDate = from

        // this.reportToDate = moment(to).add(1, "days").format("YYYY-MM-DD");
        this.reportToDate = to
        localStorage.setItem(
          "filtersReportDateRange",
          JSON.stringify({
            reportDateRange: this.reportDateRange,
            // pagination: this.pagination,
          })
        );

        console.log("Value saved to local storage:", {
          reportDateRange: this.reportDateRange,
        });
        this.$nextTick(() => {
          // this.getContractsList();
        });
        this.invoiceNumbersArray = []; 
        this.territoryArray = [];
        this.rightArray = [];
        this.movieArray = [];
        this.uniqueIdArray = [];
        this.accNumbersArray = [];
        this.currencyArray = [];
        this.getBookkeepingReport();
      }
    },
    onResetFilters() {
      this.filterApplied = false;
      this.uniqueIdArray = [];
      this.territoryArray = [];
      this.rightArray = [];
      this.movieArray = [];
      this.uniqueIdArray = [];
      this.invoiceNumbersArray = [];
      this.Array = [];
      this.currencyArray = [];
      this.filters = {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedInvDateRange: null,
        selectedMovieArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
        selectedTerArray: [],
      };
      // this.$refs["my-modal"].hide();
      let today = moment().format("YYYY-MM-DD");
      let previous = moment().startOf("month").format("YYYY-MM-DD");
      this.reportDateRange = previous + " to " + today;

      this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
      this.reportToDate = moment().endOf("month").format("YYYY-MM-DD");
    },
    onApplyFilters() {
      this.filterApplied = true;
      this.applyFilterClicked = true;
      this.appliedFilters = JSON.parse(JSON.stringify(this.filters)) ;
      localStorage.setItem(
        "filtersAndPaginationAddRevBookkeepingRevenueReport",
        JSON.stringify(this.appliedFilters)
      );
      this.getBookkeepingReport();
      this.$refs["my-modal"].hide();
    },
    onExportExcel() {
      let url = null;
      let excelName = "";
      let payload = {
        bookKeepingReportData: this.bookKeepingReportData,
        uniqueId: this.filters.selectedUniqueIdArray
          ? this.filters.selectedUniqueIdArray.toString()
          : "",
        mvi: this.filters.selectedMovieArray
          ? this.filters.selectedMovieArray.toString()
          : "",
        invDtRange: this.filters.selectedInvDateRange,
        terr: this.filters.selectedTerArray
          ? this.filters.selectedTerArray.toString()
          : "",
        right: this.filters.selectedRightArray
          ? this.filters.selectedRightArray.toString()
          : "",
        invNumbers: this.filters.selectedInvoiceArray
          ? this.filters.selectedInvoiceArray.toString()
          : "",
      };

      url = this.BASE_URL + `/bookkeeping/exportAddRevBookKeepingRevenueReport`;

      fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/Json",
          authorization: localStorage.getItem("access_token"),
          "x-access-token": localStorage.getItem("access_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const anchorElement = document.createElement("a");
          document.body.appendChild(anchorElement);
          anchorElement.style.display = "none";
          excelName = "AddRevBookKeepingRevenueReport.xlsx";
          var url = window.URL.createObjectURL(blob);
          anchorElement.href = url;
          anchorElement.download = excelName;
          anchorElement.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err, "error in onExportExcel");
        });
    },
    async getBookkeepingReport() {
      try {
        this.bookKeepingReportData = [];
        this.loadAddRevBookkeepingFilters();
        const response = await GetAdditionalRevBookKeepingRevenueReport({
          reportFromDate: this.reportFromDate,
          reportToDate: this.reportToDate,
          filters: this.filters,
        });
        if (response.data.status) {
          this.bookKeepingReportData = response.data.data;

          this.actualBookKeepingReportData = response.data.data;

          let addedInv = [];
          let addedMovie = [];
          let addedUnId = [];
          let addedTer = [];
          let addedRt = [];
          let addedCurrency = [];
          let addedAcc = [];
          for (let item of this.bookKeepingReportData) {
            if (
              item.invoice_unique_id &&
              item.invoice_unique_id != "Total" &&
              item.invoice_unique_id != "Grand Total"
            ) {
              if (!addedInv.includes(item.invoice_unique_id)) {
                let obj = {
                  id: item.invoice_unique_id,
                  value: item.invoice_unique_id,
                };
                const isInteger = Number.isInteger(
                  Number(item.invoice_unique_id)
                );
                const isDuplicateInvoiceNumbers = this.invoiceNumbersArray.some(
                  (existingItem) => existingItem.id === item.invoice_unique_id
                );
                if (isInteger && !isDuplicateInvoiceNumbers) {
                  this.invoiceNumbersArray.push(obj);
                  addedInv.push(item.invoice_unique_id);
                }
              }
              if (!addedMovie.includes(item.title)) {
                let obj1 = {
                  id: item.title,
                  value: item.title,
                };
                this.movieArray.push(obj1);
                addedMovie.push(item.title);
              }
              if (!addedUnId.includes(item.uniqueId)) {
                let objU = {
                  id: item.uniqueId,
                  value: item.uniqueId,
                };
                this.uniqueIdArray.push(objU);
                addedUnId.push(item.uniqueId);
              }

              if (!addedRt.includes(item.rightIdentifier)) {
                let objR = {
                  id: item.rightIdentifier,
                  value: item.rightIdentifier,
                };
                this.rightArray.push(objR);
                addedRt.push(item.rightIdentifier);
              }
              if (!addedAcc.includes(item.iban)) {
                let obj66 = {
                  id: item.iban,
                  value: item.iban,
                };
                const trimmedAccIdentifier = item.iban ? item.iban.trim() : "";
                const isDuplicateAccArray = this.accNumbersArray.some(
                  (existingItem) => existingItem.id === item.iban
                );
                if (
                  trimmedAccIdentifier !== "" &&
                  !addedAcc.includes(trimmedAccIdentifier) &&
                  !isDuplicateAccArray
                ) {
                  this.accNumbersArray.push(obj66);
                  addedAcc.push(item.iban);
                }
              }
              if (item.selectedCurrency) {
                if (!addedCurrency.includes(item.selectedCurrency)) {
                  let obj2 = {
                    id: item.selectedCurrency,
                    value: item.selectedCurrency,
                  };
                  const isDuplicateCurrencyArray = this.currencyArray.some(
                    (existingItem) => existingItem.id === item.selectedCurrency
                  );
                  if (!isDuplicateCurrencyArray) {
                    this.currencyArray.push(obj2);
                    addedCurrency.push(item.selectedCurrency);
                  }
                }
              }

              if (!addedTer.includes(item.territory)) {
                let objT = {
                  id: item.territory,
                  value: item.territory,
                };
                this.territoryArray.push(objT);
                addedTer.push(item.territory);
              }
            }
          }
        }
        console.log(response, "response");
      } catch (error) {
        console.log("Error in getBookkeepingReport", error);
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-outline-primary", "text-info"];
      }
    },
    loadAddRevBookkeepingFilters() {
      let localStorageFilters = localStorage.getItem(
        "filtersAndPaginationAddRevBookkeepingRevenueReport"
      );
      if (localStorageFilters) {
        let parsedFilters = JSON.parse(localStorageFilters);
        this.filters = parsedFilters;
        this.appliedFilters = this.filters;
        if (
          this.filters.selectedInvoiceArray.length > 0 ||
          this.filters.selectedaccArray.length > 0 ||
          this.filters.selectedCurrencyArray > 0
        ) {
          this.filterApplied = true;
        }
      }
    },
    loadReportToDateData() {
      const reportDateRange = localStorage.getItem("filtersReportDateRange");
      if (reportDateRange) {
        const obj = JSON.parse(reportDateRange);
        // this.pagination = obj.pagination;
        this.reportDateRange = obj.reportDateRange;
        this.$forceUpdate();
      }
      console.log(`The date range is ${this.reportDateRange}`);
    },
    handleResetButtonClicked() {
      console.log("Reset button is clicked");
      localStorage.removeItem("filtersReportDateRange");
      localStorage.removeItem(
        "filtersAndPaginationAddRevBookkeepingRevenueReport"
      );
      this.filterApplied = false;
      const isFirstDayOfMonth = moment().date() === 1;
      if(isFirstDayOfMonth){
        this.reportDateRange = `${moment().subtract(15, "days").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
        this.reportFromDate = moment().subtract(15, "days").format("YYYY-MM-DD");
        this.reportToDate = moment().format("YYYY-MM-DD");
      }
      else {
        this.reportDateRange = `${moment().startOf("month").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
        this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
        this.reportToDate = moment().format("YYYY-MM-DD");
      }

      this.filters = {
        selectedInvoiceArray: [],
        selectedMovieArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedTerArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
      };
      this.invoiceNumbersArray = [];
      this.movieArray = [];
      this.territoryArray = [];
      this.rightArray = [];
      this.uniqueIdArray = [];
      this.accNumbersArray = [];
      this.currencyArray = [];
      this.getBookkeepingReport();
    },
  },
  mounted() {
    this.loadReportToDateData();
    this.loadAddRevBookkeepingFilters();
  },
};
</script>

<style lang="scss" scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  color: #000;
  border: 2px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-weight: 550;
  font-weight: 400;
}
tr:hover {
  background-color: yellow;
}
</style>
